import React, { useEffect, useRef, useState } from "react";
import styles from "./idleOverlay.module.scss";
import pointer_animated from "../../../assets/images/hand_gestures/point-animated.svg";

export const IdleOverlay = () => {
  const positions = [
    ["50%", "50%"],
    ["70%", 0],
    [0, "50%"],
    ["-15%", 0],
  ];

  const interval = useRef();

  const [currentPosition, setCurrentPosition] = useState(0);

  useEffect(() => {
    interval.current = setInterval(() => {
      setCurrentPosition((prevState) => ++prevState % positions.length);
    }, 8000);
    return () => {
      clearInterval(interval.current);
    };
  }, []);
  return (
    <div className={styles.container}>
      <img
        className={styles.gestureImage}
        height={"50%"}
        width={"50%"}
        style={{
          zIndex: 100,
          top: positions[currentPosition][0],
          left: positions[currentPosition][1],
        }}
        src={pointer_animated}
      />
    </div>
  );
};

export default IdleOverlay;
